import { MenuItem } from '@otas/core/services/menu.service';
import {
    EXPENSE_MODULE_ROLES, COMMON_ROLES, POOJA_MODULE_ROLES,
    AUDITORIUM_MODULE_ROLES, PAYROLL_MODULE_ROLES, BANK_MODULE_ROLES,
    STORE_MODULE_ROLES, MEMBERSHIP_MODULE_ROLES, REPORT_MODULE_ACCESS, REPORT_MODULE, POOJA_REPORT_ROLES, DEVASWOM_REPORT_MODULE, DEVASWOM_BILLING_MODULE, ACCOUNT_MODULE_ROLES, ACCOUNTANT_ROLES,
    RENTAL_MODULE_ROLES, AUCTION_MODULE_ROLES, ACCOMMODATION_MODULE_ROLES, FUNCTION_HALL_MODULE_ROLES
} from './roles';
export class Menus {

    menus: Array<MenuItem> =
        [
            {
                id: 'home',
                text: '',
                icon: 'home',
                route: 'dashboard',
                active: false,
                roles: [
                    ...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...EXPENSE_MODULE_ROLES, ...AUDITORIUM_MODULE_ROLES,
                    ...PAYROLL_MODULE_ROLES, ...BANK_MODULE_ROLES, ...STORE_MODULE_ROLES, ...MEMBERSHIP_MODULE_ROLES
                ],
                megamenu: false,
                submenu: null
            },

            {
                id: 'administration',
                text: 'Administration',
                icon: '',
                route: null,
                active: false,
                roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...EXPENSE_MODULE_ROLES, ...STORE_MODULE_ROLES,
                    ...MEMBERSHIP_MODULE_ROLES,
                    'FUNCTION_HALL_FULL_ACCESS'],
                megamenu: false,
                submenu: [
                    {
                        id: 'acc-head',
                        text: 'Account Head',
                        icon: '',
                        route: 'account-head',
                        active: false,
                        roles: [...COMMON_ROLES, 'EXPENSE_FULL_ACCESS', 'POOJA_FULL_ACCESS', ...STORE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        // WS-IDP: the ACCOUNT config screen — named transaction
                        // templates (name, type, Dr/Cr head shortlists, field
                        // toggles) that billing staff post from the Identified
                        // Payment entry screen. Gated to the ACCOUNT family
                        // (backend guard accountVoucherAccess).
                        id: 'identified-payment-setup',
                        text: 'Identified Payment Setup',
                        icon: '',
                        route: 'identified-payment-v2/setup',
                        active: false,
                        roles: [...COMMON_ROLES, ...ACCOUNTANT_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        // WS-ACC Phase 2 + R74: the SINGLE account-corrections
                        // window — CoA merge/cleanup wizard (owner D5 — never
                        // automatic; every merge explicitly confirmed), the
                        // canonical Head Remap and the Voucher Backfill. Screen
                        // renders read-only for auditors; write endpoints are
                        // accountingWriteAccess server-side.
                        id: 'coa-merge',
                        text: 'Account Corrections',
                        icon: '',
                        route: 'accounting-v2/coa-merge',
                        active: false,
                        roles: [...COMMON_ROLES, ...ACCOUNTANT_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        // WS-ACC Phase 3: Financial Year Closing (Option B —
                        // soft/hard close wizard, derived balances). Fills the
                        // slot of the dead acc-balance entry deleted in Phase 0.
                        id: 'financial-year',
                        text: 'Financial Year Closing',
                        icon: '',
                        route: 'accounting-v2/financial-year',
                        active: false,
                        roles: [...COMMON_ROLES, ...ACCOUNTANT_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },

                    {
                        id: 'date-configuration',
                        text: 'Date Configuration',
                        icon: '',
                        route: 'date-configuration/date-configuration',
                        active: false,
                        roles: ['COMPANY_ACCESS', 'DATE_CONFIGURATION_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    // WS-ACC Phase 0 (2026-07-25): the dead 'acc-balance' entry is DELETED.
                    // Its route administration/account-balance never existed in
                    // app-routing.module.ts (fell through to PageNotFound), and its
                    // 'COMPANY_ACCESS ' role carried a trailing space. The Financial Year
                    // screen (accounting-v2/financial-year, WS-ACC phase 3) is its
                    // successor in this Administration slot.
                    {
                        id: 'vazhipad-head',
                        text: 'Vazhipadu Head',
                        icon: '',
                        route: 'vazhipadu-v2',
                        active: false,
                        roles: [...COMMON_ROLES, 'POOJA_FULL_ACCESS', 'POOJA_MASTER_DATA_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        // Classic entry - module-version-menu.ts strips it in
                        // BOTH versions (on V1 the primary 'vazhipad-head'
                        // entry is rewired to this route instead).
                        id: 'vazhipad-head-classic',
                        text: 'Vazhipadu Head (Classic)',
                        icon: '',
                        route: 'stoda/add-pooja',
                        active: false,
                        roles: [...COMMON_ROLES, 'POOJA_FULL_ACCESS', 'POOJA_MASTER_DATA_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'product',
                        text: 'Product',
                        icon: '',
                        route: 'expense/expense-head',
                        active: false,
                        roles: [...COMMON_ROLES, 'EXPENSE_FULL_ACCESS', ...STORE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    // {
                    //     id: 'store',
                    //     text: 'Store',
                    //     icon: '',
                    //     route: 'store/store',
                    //     active: false,
                    //     roles: [...COMMON_ROLES],
                    //     groupBy: 'Administraion',
                    //     submenu: null
                    // },
                    {
                        id: 'member-product',
                        text: 'Member Heads',
                        icon: '',
                        route: 'member-product',
                        active: false,
                        roles: [...COMMON_ROLES, ...MEMBERSHIP_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'add-auditorium',
                        text: 'Auditorium',
                        icon: '',
                        route: 'add-auditorium/add-auditorium',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITORIUM_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'rental-items-v2',
                        text: 'Rental Items',
                        icon: '',
                        route: 'rental-v2/items',
                        active: false,
                        roles: [...COMMON_ROLES, ...RENTAL_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'lelam-stock-v2',
                        text: 'Lelam Stock',
                        icon: '',
                        route: 'auction-v2/stock',
                        active: false,
                        roles: [...COMMON_ROLES, ...AUCTION_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'accommodation-rooms-v2',
                        text: 'Guest Houses & Rooms',
                        icon: '',
                        route: 'accommodation-v2/rooms',
                        active: false,
                        roles: [...COMMON_ROLES, ...ACCOMMODATION_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    // WS-FHP Function Hall setup (otas_backend/docs/FUNCTION_HALL_PRIEST_MODULE.md
                    // §6.8). Deliberately NOT gated on VENUE_MODULE: the Settings
                    // screen is where VENUE_MODULE is switched, so gating it on the
                    // value it sets would make FUNCTION_HALL unreachable from the
                    // menu of a default (AUDITORIUM) temple. FULL roles only —
                    // both screens are functionHallFullAccess server-side.
                    {
                        id: 'function-hall-masters',
                        text: 'Function Hall Masters',
                        icon: '',
                        route: 'function-hall-v2/masters',
                        active: false,
                        roles: [...COMMON_ROLES, 'FUNCTION_HALL_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'function-hall-settings',
                        text: 'Function Hall Settings',
                        icon: '',
                        route: 'function-hall-v2/settings',
                        active: false,
                        roles: [...COMMON_ROLES, 'FUNCTION_HALL_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'devotee',
                        text: 'Devotee',
                        icon: '',
                        route: 'devotee',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES],
                        groupBy: 'Services',
                        submenu: null
                    },
                    {
                        // Member entry form: Route is rewired by the module-version toggle:
                        // membership-v2 on V2 (default), membership/add-member-on on V1.
                        id: 'member-heads',
                        text: 'Member',
                        icon: '',
                        route: 'membership-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...MEMBERSHIP_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'member-product-heads',
                        text: 'Member Heads',
                        icon: '',
                        route: 'membership/add-member-ship',
                        active: false,
                        roles: [...COMMON_ROLES, ...MEMBERSHIP_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'customer',
                        text: 'Vendor / Customer',
                        icon: '',
                        route: 'vendor/vendor-customer',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES],
                        groupBy: 'Services',
                        submenu: null
                    },
                    {
                        id: 'employees',
                        text: 'Employees',
                        icon: '',
                        route: 'employees',
                        active: false,
                        roles: [...COMMON_ROLES, 'PAYROLL_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    }

                    // , {
                    //     id: 'user',
                    //     text: 'User',
                    //     icon: '',
                    //     route: 'administration/user',
                    //     active: false,
                    //     roles: ['FULL_ACCESS','COMPANY_ACCESS ', ],
                    //     groupBy: 'Administraion',
                    //     submenu: null
                    // },
                    // {
                    //     id: 'membership',
                    //     text: 'Membership',
                    //     icon: '',
                    //     route: 'stoda/membership/add-membership',
                    //     active: false,
                    //     roles: ['FULL_ACCESS','COMPANY_ACCESS ', ],
                    //     groupBy: 'Administraion',
                    //     submenu: null
                    // },
                    // {
                    //     id: 'members',
                    //     text: 'Members',
                    //     icon: '',
                    //     route: 'stoda/membership/add-member',
                    //     active: false,
                    //     roles: ['FULL_ACCESS','COMPANY_ACCESS ', ],
                    //     groupBy: 'Administraion',
                    //     submenu: null
                    // }
                ]
            },
            {
                id: 'Transaction',
                text: 'Transaction',
                icon: '',
                route: null,
                active: false,
                roles: [
                    ...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...EXPENSE_MODULE_ROLES, ...AUDITORIUM_MODULE_ROLES,
                    ...PAYROLL_MODULE_ROLES, ...BANK_MODULE_ROLES, ...STORE_MODULE_ROLES, ...MEMBERSHIP_MODULE_ROLES,
                    ...FUNCTION_HALL_MODULE_ROLES
                ],
                megamenu: false,
                submenu: [
                    {
                        id: 'vazhipad',
                        text: 'Vazhipadu',
                        icon: '',
                        route: 'pooja-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        // Classic entry - module-version-menu.ts strips it in
                        // BOTH versions (on V1 the primary 'vazhipad' entry
                        // is rewired to this route instead).
                        id: 'vazhipad-classic',
                        text: 'Vazhipadu (Classic)',
                        icon: '',
                        route: 'pooja/pooja-booking-stoda',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'sale',
                        text: 'Pooja Stall',
                        icon: '',
                        route: 'stoda/sale',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'expense',
                        text: 'Expense',
                        icon: '',
                        route: 'stoda/expense-billing-stoda',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },    
                    {
                        id: 'store-pass',
                        text: 'Store Pass',
                        icon: '',
                        route: 'stoda/store-pass',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'store-transfer',
                        text: 'Store Transfer',
                        icon: '',
                        route: 'stoda/store-transfer',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },   
                    {
                        id: 'damage-enquiry',
                        text: 'Material Refund',
                        icon: '',
                        route: 'stoda/perishable-item-enquiry',
                        active: false,
                        // GET temple/perishable/items -> backend expenseBillingAccess
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, ...STORE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        // Income billing (WS-H). Route is rewired by the module-version
                        // toggle: income-v2 on V2 (default), stoda/income-billing on V1.
                        id: 'income',
                        text: 'Income',
                        icon: '',
                        route: 'income-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'bank',
                        text: 'Bank',
                        icon: '',
                        route: 'stoda/bank-transaction',
                        active: false,
                        roles: [...COMMON_ROLES, ...BANK_MODULE_ROLES],
                        groupBy: 'Services',
                        submenu: null
                    },
                    // WS-ACM Accommodation module (V2-only; otas_backend/docs/ACCOMMODATION_MODULE.md)
                    {
                        id: 'accommodation-v2',
                        text: 'Accommodation',
                        icon: '',
                        route: 'accommodation-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...ACCOMMODATION_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'membership-billing',
                        text: 'Membership',
                        icon: '',
                        route: 'membership/membership-booking',
                        active: false,
                        roles: [...COMMON_ROLES, ...MEMBERSHIP_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'auditorium',
                        text: 'Auditorium',
                        icon: '',
                        route: 'auditorium',
                        active: false,
                        roles: [...COMMON_ROLES, ...AUDITORIUM_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    // WS-FHP Function Hall + Priest (V2-only;
                    // otas_backend/docs/FUNCTION_HALL_PRIEST_MODULE.md). These two
                    // entries and the 'auditorium'/'add-auditorium' pair are
                    // MUTUALLY EXCLUSIVE on the temple's VENUE_MODULE (owner
                    // decision D-FHP-9, applied by applyVenueModuleToMenus in
                    // services/module-version-menu.ts): default AUDITORIUM hides
                    // these, FUNCTION_HALL hides the auditorium pair instead.
                    {
                        id: 'function-hall',
                        text: 'Function Hall',
                        icon: '',
                        route: 'function-hall-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...FUNCTION_HALL_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'priest-appointment',
                        text: 'Priest Appointment',
                        icon: '',
                        route: 'function-hall-v2/priest',
                        active: false,
                        roles: [...COMMON_ROLES, ...FUNCTION_HALL_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    // WS-R Rental module (V2-only; otas_backend/docs/RENTAL_MODULE.md)
                    {
                        id: 'rental-v2',
                        text: 'Rental',
                        icon: '',
                        route: 'rental-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...RENTAL_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    // WS-L Auction (Lelam) module (V2-only; otas_backend/docs/AUCTION_MODULE.md)
                    {
                        id: 'auction-v2',
                        text: 'Auction (Lelam)',
                        icon: '',
                        route: 'auction-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...AUCTION_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },           
                    {
                        id: 'salary',
                        text: 'Salary',
                        icon: '',
                        route: 'salary/salary',
                        active: false,
                        roles: [...COMMON_ROLES, ...PAYROLL_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        id: 'remittance',
                        text: 'Remittance',
                        icon: '',
                        route: 'stoda/remittance',
                        active: false,
                        roles: [...COMMON_ROLES, ...DEVASWOM_BILLING_MODULE],
                        groupBy: 'Administraion',
                        submenu: null
                    },  
                    {
                        // WS-IDP: repointed to the V2 entry screen (the legacy
                        // stoda/identified-payment stays URL-reachable as
                        // rollback). Billing staff post pre-configured
                        // templates; roles = the bank-transaction billing
                        // family (matches the backend posting guard).
                        id: 'identified-payment',
                        text: 'Identified Payment',
                        icon: '',
                        route: 'identified-payment-v2',
                        active: false,
                        roles: [...COMMON_ROLES, ...BANK_MODULE_ROLES],
                        groupBy: 'Administraion',
                        submenu: null
                    },
                    {
                        // WS-ACC Phase 1 (2026-07-25): the accountant's Manual
                        // Journal — replaces the deleted legacy stoda/payment
                        // screen, whose endpoint never once posted a correct
                        // entry (it committed orphan invoice rows with no
                        // accounting and no voucher). ACCOUNTANT_ROLES so an
                        // ACCOUNT-only user sees it (the backend write guard
                        // accountingWriteAccess accepts ACCOUNT).
                        id: 'journal-entry',
                        text: 'Journal Entry',
                        icon: '',
                        route: 'accounting-v2/journal',
                        active: false,
                        roles: [...COMMON_ROLES, ...ACCOUNTANT_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        groupBy: 'Administraion',
                        submenu: null
                    }
                    // {
                    //     id: 'attendance',
                    //     text: 'Attendance',
                    //     icon: '',
                    //     route: 'salary/attendance',
                    //     active: false,
                    //     roles: [...COMMON_ROLES, ...PAYROLL_MODULE_ROLES],
                    //     groupBy: null,
                    //     submenu: null
                    // }                                      
                ]

            },
            {
                // Enquiry column (owner directive 2026-07-23): every enquiry /
                // register screen under ONE head after Transaction - the three
                // entries moved out of Transaction (Online Pooja / Material
                // Refund / Cheque) plus the enquiry screens that never had a
                // menu entry of their own.
                id: 'enquiry',
                text: 'Enquiry',
                icon: '',
                route: null,
                active: false,
                roles: [
                    ...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...EXPENSE_MODULE_ROLES, ...AUDITORIUM_MODULE_ROLES,
                    ...PAYROLL_MODULE_ROLES, ...BANK_MODULE_ROLES, ...STORE_MODULE_ROLES, ...MEMBERSHIP_MODULE_ROLES,
                    ...RENTAL_MODULE_ROLES, ...AUCTION_MODULE_ROLES, ...ACCOMMODATION_MODULE_ROLES,
                    ...FUNCTION_HALL_MODULE_ROLES
                ],
                megamenu: false,
                submenu: [
                    {
                        // Route rewired by the module-version toggle
                        // (MODULE_ROUTE_MAP): pooja-enquiry-v2 on V2 (default),
                        // the classic stoda/pooja-enquiry screen on V1.
                        id: 'vazhipadu-enquiry',
                        text: 'Vazhipadu Enquiry',
                        icon: '',
                        route: 'pooja-enquiry-v2',
                        active: false,
                        // GET pooja/enquiry -> backend poojaBillingAccess
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...STORE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'online-enquiry',
                        text: 'Online Pooja Enquiry',
                        icon: '',
                        route: 'stoda/online-pooja-enquiry',
                        active: false,
                        // GET pooja/enquiry/online/{index} -> backend poojaBillingAccess
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...STORE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'sales-enquiry',
                        text: 'Pooja Stall Enquiry',
                        icon: '',
                        route: 'stoda/sales/sales-enquiry',
                        active: false,
                        // GET pooja/enquiry -> backend poojaBillingAccess
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...STORE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'expense-enquiry',
                        text: 'Expense Enquiry',
                        icon: '',
                        route: 'stoda/create-bill',
                        active: false,
                        // GET temple/expense/billing -> backend expenseBillingAccess
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, ...STORE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'income-enquiry',
                        text: 'Income Enquiry',
                        icon: '',
                        route: 'stoda/create-invoice',
                        active: false,
                        // GET temple/income/billing -> backend expenseBillingAccess
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, ...STORE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'cheque-enquiry',
                        text: 'Cheque Enquiry',
                        icon: '',
                        route: 'stoda/cheque-enquiry',
                        active: false,
                        // GET payment/pending/list -> backend allBookingAccess. Note:
                        // the guard accepts BANK_TRANSACTION_FULL_ACCESS but NOT
                        // BANK_TRANSACTION_BILLING_ACCESS, so BANK_MODULE_ROLES is
                        // deliberately not spread here.
                        roles: [...COMMON_ROLES, ...POOJA_MODULE_ROLES, ...EXPENSE_MODULE_ROLES, ...AUDITORIUM_MODULE_ROLES,
                            ...PAYROLL_MODULE_ROLES, ...MEMBERSHIP_MODULE_ROLES, ...STORE_MODULE_ROLES, ...ACCOUNT_MODULE_ROLES,
                            'BANK_TRANSACTION_FULL_ACCESS', 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'accommodation-enquiry-v2',
                        text: 'Accommodation Enquiry',
                        icon: '',
                        route: 'accommodation-v2/enquiry',
                        active: false,
                        // GET v2/accommodation/enquiry -> backend accommodationBillingAccess
                        roles: [...COMMON_ROLES, ...ACCOMMODATION_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'rental-enquiry-v2',
                        text: 'Rental Enquiry',
                        icon: '',
                        route: 'rental-v2/enquiry',
                        active: false,
                        // GET v2/rental/enquiry -> backend rentalBillingAccess
                        roles: [...COMMON_ROLES, ...RENTAL_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'auction-enquiry-v2',
                        text: 'Auction Enquiry',
                        icon: '',
                        route: 'auction-v2/enquiry',
                        active: false,
                        // GET v2/auction/enquiry -> backend auctionBillingAccess
                        roles: [...COMMON_ROLES, ...AUCTION_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    // WS-FHP: the enquiry half of the VENUE_MODULE-exclusive set
                    // (D-FHP-9) — hidden while the temple runs AUDITORIUM.
                    {
                        id: 'function-hall-enquiry',
                        text: 'Function Hall Enquiry',
                        icon: '',
                        route: 'function-hall-v2/enquiry',
                        active: false,
                        // GET v2/function-hall/enquiry -> backend functionHallBillingAccess
                        roles: [...COMMON_ROLES, ...FUNCTION_HALL_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    },
                    {
                        id: 'priest-enquiry',
                        text: 'Priest Enquiry',
                        icon: '',
                        route: 'function-hall-v2/priest-enquiry',
                        active: false,
                        // GET v2/priest/enquiry -> backend functionHallBillingAccess
                        roles: [...COMMON_ROLES, ...FUNCTION_HALL_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: 'Enquiry',
                        submenu: null
                    }
                ]
            },
            {
                id: 'reports',
                text: 'Reports',
                icon: '',
                route: null,
                active: false,
                roles: [...REPORT_MODULE_ACCESS],
                groupBy: 'Report',
                megamenu: false,
                submenu: [                    
                    {
                        id: 'pooja-collection-report-revised',
                        text: 'Pooja Collection',
                        icon: '',
                        route: 'reports/pooja-collection-report-revised',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE, 'POOJA_BILLING_ACCESS'],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        // The detail-driven Pooja Collection (V2) screen
                        // (reports-v2/pooja-collection): ONE fetch of the flat
                        // v2/report/pooja-collection/detail feed + the full
                        // legacy filter panel rebuilt client-side. Shown only
                        // while VAZHIPADU runs V2 (module-version-menu.ts strips
                        // it on V1).
                        id: 'pooja-collection-jspdf-v2',
                        text: 'Pooja Collection (V2)',
                        icon: '',
                        route: 'reports-v2/pooja-collection',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE, 'POOJA_BILLING_ACCESS'],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-collection-report-online',
                        text: 'Online Collection',
                        icon: '',
                        route: 'reports/pooja-collection-report-online',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        // jsPDF V2 counterpart. Shown only while VAZHIPADU runs
                        // V2 (module-version-menu.ts strips it on V1).
                        id: 'online-collection-v2',
                        text: 'Online Collection (V2)',
                        icon: '',
                        route: 'reports-v2/online-collection',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-collection-report',
                        text: 'Pooja Invoices',
                        icon: '',
                        route: 'reports/pooja/collection',
                        active: false,
                        roles: [...COMMON_ROLES],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        // jsPDF-rendered V2 counterpart of the Pooja Invoices
                        // screen. Shown only while VAZHIPADU runs V2
                        // (module-version-menu.ts strips it on V1). Roles
                        // copy the legacy 'pooja-collection-report' entry.
                        id: 'pooja-invoices-jspdf-v2',
                        text: 'Pooja Invoices (V2)',
                        icon: '',
                        route: 'reports-v2/pooja-invoices',
                        active: false,
                        roles: [...COMMON_ROLES],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    // { // under development
                    //     id: 'pooja-invoices-report-revised',
                    //     text: 'Pooja Invoices Revised',
                    //     icon: '',
                    //     route: 'reports/pooja-invoices-report-revised',
                    //     active: false,
                    //     roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                    //     mmgroupBy: 'Pooja',sortOrder:1,
                    //     submenu: null
                    // },
                    {
                        id: 'pooja-list-report',
                        text: 'Pooja Bookings v1',
                        icon: '',
                        route: 'reports/pooja/pooja-list',
                        active: false,
                        roles: [...COMMON_ROLES],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },                    
                    {
                        id: 'pooja-list-report-revised',
                        text: 'Pooja Bookings',
                        icon: '',
                        route: 'reports/pooja-list-report-revised',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE, 'POOJA_BILLING_ACCESS'],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        // jsPDF-rendered V2 counterpart (Malayalam
                        // verification pilot). Shown only while VAZHIPADU
                        // runs V2 (module-version-menu.ts strips it on V1).
                        id: 'pooja-bookings-jspdf-v2',
                        text: 'Pooja Bookings (V2)',
                        icon: '',
                        route: 'reports-v2/pooja-bookings',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE, 'POOJA_BILLING_ACCESS'],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-category-list',
                        text: 'Pooja Category List',
                        icon: '',
                        route: 'reports/pooja/pooja-category-list',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-category-list-v2',
                        text: 'Pooja Category List (V2)',
                        icon: '',
                        route: 'reports-v2/pooja-category-list',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-monthly-collection-report',
                        text: 'Monthly Pooja',
                        icon: '',
                        route: 'reports/pooja-monthly-collection-report',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'monthly-pooja-v2',
                        text: 'Monthly Pooja (V2)',
                        icon: '',
                        route: 'reports-v2/monthly-pooja',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'star-pooja-report',
                        text: 'Star Wise Pooja Report',
                        icon: '',
                        route: 'reports/star-pooja-report',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'star-pooja-v2',
                        text: 'Star Wise Pooja Report (V2)',
                        icon: '',
                        route: 'reports-v2/star-pooja',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'personal-id-pooja-report',
                        text: 'Registered Devotee Pooja',
                        icon: '',
                        route: 'reports/personal-id-pooja-report',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'registered-devotee-v2',
                        text: 'Registered Devotee Pooja (V2)',
                        icon: '',
                        route: 'reports-v2/registered-devotee',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-summary',
                        text: 'Pooja Summary',
                        icon: '',
                        route: 'reports/pooja-summary',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-summary-v2',
                        text: 'Pooja Summary (V2)',
                        icon: '',
                        route: 'reports-v2/pooja-summary',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'per-pooja-report',
                        text: 'Per Pooja Items',
                        icon: '',
                        route: 'reports/per-pooja-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'per-pooja-items-v2',
                        text: 'Per Pooja Items (V2)',
                        icon: '',
                        route: 'reports-v2/per-pooja-items',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'manual-entry-report',
                        text: 'Manual Entry Report',
                        icon: '',
                        route: 'reports/manual-entry-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'manual-entry-v2',
                        text: 'Manual Entry Report (V2)',
                        icon: '',
                        route: 'reports-v2/manual-entry',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },
                    {
                        id: 'pooja-collection-monthly',
                        text: 'Devaswom Report',
                        icon: '',
                        route: 'reports/pooja-collection-monthly',
                        active: false,
                        roles: ['COMPANY_ACCESS', 'AUDITOR_ACCESS', ...DEVASWOM_REPORT_MODULE],
                        mmgroupBy: 'Pooja',sortOrder:1,
                        submenu: null
                    },    
                    {
                        // F-R8 (WS-F F7 menu re-org): id was 'expense' -
                        // collided with the Administration expense-billing
                        // entry (route stoda/expense-billing-stoda). Menu ids
                        // must be unique; renamed to the report-specific id.
                        id: 'expense-report',
                        text: 'Expense Report',
                        icon: '',
                        route: 'reports/expense',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...EXPENSE_MODULE_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // WS-F phase F6a: corrected legacy Expense Report
                        // (jsPDF, `v2/report/expense`). Expense column; V2-only
                        // (module-version-menu.ts strips it on V1). Roles copy
                        // the legacy 'expense' entry (same backend guard).
                        id: 'expense-report-v2',
                        text: 'Expense Report (V2)',
                        icon: '',
                        route: 'reports-v2/expense',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...EXPENSE_MODULE_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'nadavaravu-report',
                        text: 'Nadavaravu Report',
                        icon: '',
                        route: 'reports/nadavaravu-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // WS-F phase F6b: jsPDF Nadavaravu report over
                        // `v2/report/nadavaravu` (invoice-date basis). Expense
                        // column; V2-only (module-version-menu.ts strips it on
                        // V1). Roles copy the legacy 'nadavaravu-report' entry.
                        id: 'nadavaravu-v2',
                        text: 'Nadavaravu Report (V2)',
                        icon: '',
                        route: 'reports-v2/nadavaravu',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'nadavaravu-report-revised',
                        text: 'Nadavaravu Report Revised',
                        icon: '',
                        route: 'reports/nadavaravu-report-revised',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },                   
                    {
                        // V2 (owner directive 2026-07-14): faithful jsPDF
                        // Nadavaravu Report Revised over the new
                        // report/nadavaravu/revised JSON passthrough; V2-only.
                        id: 'nadavaravu-revised-v2',
                        text: 'Nadavaravu Report Revised (V2)',
                        icon: '',
                        route: 'reports-v2/nadavaravu-revised',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'postage-report',
                        text: 'Postage',
                        icon: '',
                        route: 'reports/postage',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // WS-F phase F6c: jsPDF Postage report over
                        // `v2/report/postage` (pooja-date basis, POSTAGE=true).
                        // Expense column; V2-only (module-version-menu.ts strips
                        // it on V1). Roles copy the legacy 'postage-report' entry.
                        id: 'postage-v2',
                        text: 'Postage (V2)',
                        icon: '',
                        route: 'reports-v2/postage',
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'avakasi-vihitham-report',
                        text: 'Avakasi Vihitham',
                        icon: '',
                        route: 'reports/avakasi-vihitham-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // WS-F phase F6b: jsPDF Avakasi Vihitham report over
                        // `v2/report/avakasi-vihitham` (pooja-date basis).
                        // Expense column; V2-only (module-version-menu.ts strips
                        // it on V1). Roles copy the legacy
                        // 'avakasi-vihitham-report' entry.
                        id: 'avakasi-vihitham-v2',
                        text: 'Avakasi Vihitham (V2)',
                        icon: '',
                        route: 'reports-v2/avakasi-vihitham',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    // {
                    //     id: 'expense',
                    //     text: 'Income Report',
                    //     icon: '',
                    //     route: 'reports/expense',
                    //     active: false,
                    //     roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                    //     mmgroupBy: null,
                    //     submenu: null
                    // },
                    {
                        id: 'voucher-report',
                        text: 'Voucher Report',
                        icon: '',
                        route: 'reports/voucher-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // V2 (owner directive 2026-07-14): faithful jsPDF Voucher
                        // Report over the existing report/voucher/number JSON
                        // endpoint; V2-only.
                        id: 'voucher-report-v2',
                        text: 'Voucher Report (V2)',
                        icon: '',
                        route: 'reports-v2/voucher-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'vendor-statement',
                        text: 'Vendor Statement',
                        icon: '',
                        route: 'reports/vendor-statement',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // WS-F phase F6b: jsPDF Vendor Statement over
                        // `v2/report/vendor-statement` (payment-date ledger).
                        // Expense column; V2-only (module-version-menu.ts strips
                        // it on V1). Roles copy the legacy 'vendor-statement'
                        // entry.
                        id: 'vendor-statement-v2',
                        text: 'Vendor Statement (V2)',
                        icon: '',
                        route: 'reports-v2/vendor-statement',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'attendance',
                        text: 'Attendance Report',
                        icon: '',
                        route: 'reports/attendance',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // V2 (owner directive 2026-07-14): faithful jsPDF
                        // Attendance Report (reproduces the legacy temple/employee
                        // stub); V2-only.
                        id: 'attendance-v2',
                        text: 'Attendance Report (V2)',
                        icon: '',
                        route: 'reports-v2/attendance',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'due-paid-report',
                        text: 'Partial Payment Report',
                        icon: '',
                        route: 'reports/due-paid-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },  
                    {
                        // WS-F phase F6e jsPDF Partial Payment over
                        // v2/report/partial-payment; relocated Audit->Expense
                        // beside its legacy sibling (owner directive 2026-07-14).
                        // V2-only.
                        id: 'partial-payment-v2',
                        text: 'Partial Payment (V2)',
                        icon: '',
                        route: 'reports-v2/partial-payment',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        id: 'cancelled-transaction-report',
                        text: 'Cancelled Transaction',
                        icon: '',
                        route: 'reports/cancelled-transaction',
                        mmgroupBy: 'Expense',sortOrder:2,
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6e jsPDF Cancelled Transaction over
                        // v2/report/cancelled-transaction; relocated
                        // Audit->Expense beside its legacy sibling (owner
                        // directive 2026-07-14). V2-only.
                        id: 'cancelled-transaction-v2',
                        text: 'Cancelled Transaction (V2)',
                        icon: '',
                        route: 'reports-v2/cancelled-transaction',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // F-R8: id was 'collection-report' - duplicated the
                        // Audit column's Collection entry; renamed unique.
                        id: 'cash-book-report',
                        text: 'Cash Book',
                        icon: '',
                        route: 'reports/collection',
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        mmgroupBy: 'Expense',sortOrder:2,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // V2 (owner directive 2026-07-14): faithful jsPDF Cash Book
                        // (receipts/payments transaction list over report/collection)
                        // - distinct from the voucher-ledger Cash Book (V2) in Audit.
                        // V2-only.
                        id: 'cash-book-collection-v2',
                        text: 'Cash Book (V2)',
                        icon: '',
                        route: 'reports-v2/cash-book-collection',
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        mmgroupBy: 'Expense',sortOrder:2,
                        submenu: null
                    },
                    {
                        // F-R8: id was 'income-expense-report' - collided
                        // with the Audit I&E route name; renamed unique.
                        id: 'income-expense-v1-report',
                        text: 'Income & Expense Report v1',
                        icon: '',
                        route: 'reports/income-expense',
                        active: false,
                        roles: [...COMMON_ROLES],
                        mmgroupBy: 'Expense',sortOrder:2,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F3: corrected legacy I&E statement
                        // (jsPDF, `v2/report/income-expense`). Expense column
                        // per D-F5; V2-only (module-version-menu.ts strips it
                        // on V1). NOT the voucher-backed Income & Expenditure
                        // (V2) Audit entry. Roles cover the backend
                        // auditorAccess guard like the legacy R&P entry.
                        id: 'income-expense-statement-v2',
                        text: 'Income & Expense (V2)',
                        icon: '',
                        route: 'reports-v2/income-expense-statement',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'income-expense-r-report',
                        text: 'Income & Expense Report',
                        icon: '',
                        route: 'reports/income-expense-report',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'receipt-payment',
                        text: 'Receipt & Payment',
                        icon: '',
                        route: 'reports/receipt-payment',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F3: corrected legacy R&P statement
                        // (jsPDF, `v2/report/receipt-payment`). Expense column
                        // per D-F5; V2-only (module-version-menu.ts strips it
                        // on V1). Roles copy the legacy 'receipt-payment'
                        // Audit entry (same backend guard).
                        id: 'receipt-payment-statement-v2',
                        text: 'Receipt & Payment (V2)',
                        icon: '',
                        route: 'reports-v2/receipt-payment',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Expense',sortOrder:2,
                        groupBy: null,
                        submenu: null
                    },
                    // {
                    //     id: 'receipt-payment-v2',
                    //     text: 'Receipt & Payment V2',
                    //     icon: '',
                    //     route: 'reports/receipt-payment-v2',
                    //     active: false,
                    //     roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                    //     mmgroupBy: 'Audit',sortOrder:4,
                    //     groupBy: null,
                    //     submenu: null
                    // },
                    {
                        id: 'general-ledger',
                        text: 'General Ledger',
                        icon: '',
                        route: 'reports/general-ledger',
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'pos-report',
                        text: 'CARD Report',
                        icon: '',
                        route: 'reports/pos-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'cheque-report',
                        text: 'Cheque Report',
                        icon: '',
                        route: 'reports/cheque-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6b: ONE jsPDF page serving both the legacy
                        // CARD (pos-report) and Cheque reports via a mode toggle
                        // over `v2/report/payment-mode`. Audit column to match
                        // the legacy pos-report/cheque-report placement; V2-only
                        // (module-version-menu.ts strips it on V1). Roles copy
                        // the legacy 'pos-report'/'cheque-report' entries.
                        id: 'payment-mode-v2',
                        text: 'Card / Cheque (V2)',
                        icon: '',
                        route: 'reports-v2/payment-mode',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'payable-report',
                        text: 'Payment Payable',
                        icon: '',
                        route: 'reports/payable',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6c: jsPDF Payable report over
                        // `v2/report/payable` (guard expenseBillingAccess). Audit
                        // column to match the legacy 'payable-report' home;
                        // V2-only (module-version-menu.ts strips it on V1). Roles
                        // copy the legacy 'payable-report' entry.
                        id: 'payable-v2',
                        text: 'Payment Payable (V2)',
                        icon: '',
                        route: 'reports-v2/payable',
                        active: false,
                        roles: [...COMMON_ROLES, ...EXPENSE_MODULE_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'receivable-report',
                        text: 'Payment Receivable',
                        icon: '',
                        route: 'reports/receivable',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6c: jsPDF Receivable report over
                        // `v2/report/receivable` (guard incomeReportAccess). Audit
                        // column to match the legacy 'receivable-report' home;
                        // V2-only (module-version-menu.ts strips it on V1). Roles
                        // copy the legacy 'receivable-report' entry.
                        id: 'receivable-v2',
                        text: 'Payment Receivable (V2)',
                        icon: '',
                        route: 'reports-v2/receivable',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, ...POOJA_REPORT_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        groupBy: null,
                        submenu: null
                    },
                    // {
                    //     id: 'cheque-clearance-report',
                    //     text: 'Cheque Clearance Report',
                    //     icon: '',
                    //     route: 'stoda/cheque-enquiry/cheque-clearance-report',
                    //     active: false,
                    //     roles: [...COMMON_ROLES, 'AUDITOR_ACCESS'],
                    //     groupBy: null,
                    //     submenu: null
                    // },                                        
                    {
                        // Workstream E phase 2: first voucher-backed jsPDF
                        // report. Shown only while the VAZHIPADU module runs
                        // V2 (applyVazhipaduVersionToMenus hides it on V1);
                        // roles mirror the app-routing `reports-v2` entry
                        // (backend guard: ACCOUNT role or admin authorities).
                        id: 'voucher-collection-report-v2',
                        text: 'Collection Report (V2)',
                        icon: '',
                        route: 'reports-v2/collection',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'collection-report',
                        text: 'Collection',
                        icon: '',
                        route: 'reports/collection-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },                    
                    {
                        id: 'cash-book-revised-report',
                        text: 'Cash Book Revised',
                        icon: '',
                        route: 'reports/cash-book-revised-report',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Audit',sortOrder:4,
                        groupBy: null,
                        submenu: null
                    },                                                      
                    {
                        id: 'day-book',
                        text: 'Day Book',
                        icon: '',
                        route: 'reports/day-book',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6d: jsPDF Day Book report over
                        // `v2/report/day-book` (guard allBookingAccess). Audit
                        // column to match the legacy 'day-book' home; V2-only
                        // (module-version-menu.ts strips it on V1). Roles copy
                        // the legacy 'day-book' entry.
                        id: 'day-book-v2',
                        text: 'Day Book (V2)',
                        icon: '',
                        route: 'reports-v2/day-book',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS'],
                        groupBy: null,
                        submenu: null
                    },
                    // Partial Payment (V2) + Cancelled Transaction (V2) were
                    // relocated Audit->Expense to sit beside their legacy siblings
                    // (owner directive 2026-07-14) - see the Expense column above.
                    // legacy journal-backed Trial Balance / Balance Sheet / Income Expenditure removed (WS-F: journal retired; V2 voucher reports replace them)
                    // Voucher-backed financial reports (V2, WS-E financial
                    // batch). Shown only while VAZHIPADU runs V2
                    // (module-version-menu.ts strips them on V1). Roles copy
                    // the legacy Trial Balance/Balance Sheet/Cash Book
                    // entries plus the ACCOUNT role the backend voucher
                    // guard (accountVoucherAccess) accepts.
                    {
                        id: 'trial-balance-v2',
                        text: 'Trial Balance (V2)',
                        icon: '',
                        route: 'reports-v2/trial-balance',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'balance-sheet-v2',
                        text: 'Balance Sheet (V2)',
                        icon: '',
                        route: 'reports-v2/balance-sheet',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'income-expenditure-v2',
                        text: 'Income & Expenditure (V2)',
                        icon: '',
                        route: 'reports-v2/income-expenditure',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'general-ledger-v2',
                        text: 'General Ledger (V2)',
                        icon: '',
                        route: 'reports-v2/general-ledger',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'cash-book-v2',
                        text: 'Cash Book (V2)',
                        icon: '',
                        route: 'reports-v2/cash-book',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'bank-book-v2',
                        text: 'Bank Book (V2)',
                        icon: '',
                        route: 'reports-v2/bank-book',
                        mmgroupBy: 'Audit',sortOrder:4,
                        active: false,
                        roles: [...COMMON_ROLES, 'ACCOUNTING_FULL_ACCESS', ...ACCOUNTANT_ROLES],
                        groupBy: null,
                        submenu: null
                    },
                    // R49 (owner directive 2026-07-25): the stock
                    // reports moved here from the retired top-level
                    // Stock menu - they render as the megamenu's own
                    // 'Stock' column, THIRD, before Audit (which moved
                    // to sortOrder 4). The no-stock-inventory gate now
                    // strips this column in menu.service.ts.
                    {
                        id: 'sale-summary',
                        text: 'Sale Summary',
                        icon: '',
                        route: 'reports/store-report/sale-summary',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'purchase-return',
                        text: 'Purchase Return Report',
                        icon: '',
                        route: 'reports/purchase-return',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'sales-return',
                        text: 'Sales Return Report',
                        icon: '',
                        route: 'reports/sales-return',
                        active: false,
                        roles: [...COMMON_ROLES, 'AUDITOR_ACCESS', ...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    // {
                    //     id: 'purchase-return',
                    //     text: 'Purchase Return',
                    //     icon: '',
                    //     route: 'reports/store-report/purchase-return',
                    //     active: false,
                    //     roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                    //     groupBy: null,
                    //     submenu: null
                    // },
                    {
                        id: 'collection-summary',
                        text: 'Collection Summary',
                        icon: '',
                        route: 'reports/store-report/collection-summary',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // jsPDF-rendered V2 counterpart of the Collection
                        // Summary store report. Shown only while VAZHIPADU
                        // runs V2 (module-version-menu.ts strips it on V1).
                        // Roles copy the legacy 'collection-summary' entry.
                        id: 'stock-collection-jspdf-v2',
                        text: 'Stock Collection (V2)',
                        icon: '',
                        route: 'reports-v2/stock-collection',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6a: jsPDF Stock Transfer (RECEIVE/SEND)
                        // over `v2/report/stock-transfer`. V2-only
                        // (module-version-menu.ts strips it on V1). Roles copy
                        // the sibling 'stock-collection-jspdf-v2' entry.
                        id: 'stock-transfer-v2',
                        text: 'Stock Transfer (V2)',
                        icon: '',
                        route: 'reports-v2/stock-transfer',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6a: jsPDF Stock Consumption (store-pass)
                        // over `v2/report/stock-consumption`. V2-only
                        // (module-version-menu.ts strips it on V1). Roles copy
                        // the sibling 'stock-collection-jspdf-v2' entry.
                        id: 'stock-consumption-v2',
                        text: 'Stock Consumption (V2)',
                        icon: '',
                        route: 'reports-v2/stock-consumption',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        // WS-F phase F6e: jsPDF Current Stock statement over
                        // `v2/report/current-stock` (guard stockReportAccess).
                        // V2-only (module-version-menu.ts strips it on V1). Roles
                        // copy the sibling 'stock-consumption-v2' entry.
                        id: 'current-stock-v2',
                        text: 'Current Stock (V2)',
                        icon: '',
                        route: 'reports-v2/current-stock',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'issue details',
                        text: 'Issue Details',
                        icon: '',
                        route: 'reports/store-pass-report',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'stock-report-datewise',
                        text: 'Stock Statement',
                        icon: '',
                        route: 'reports/stock-report-datewise',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'stock-report',
                        text: 'Today Stock',
                        icon: '',
                        route: 'reports/stock-report',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES, ...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'supplierwise-register',
                        text: 'Supplier wise Register',
                        icon: '',
                        route: 'reports/store-report/supplierwise-register',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'supplier-list',
                        text: 'Supplier List',
                        icon: '',
                        route: 'reports/store-report/supplier-list',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'purchase-register',
                        text: 'Purchase Register',
                        icon: '',
                        route: 'reports/expense',
                        active: false,
                        roles: [...COMMON_ROLES, ...STORE_MODULE_ROLES,...REPORT_MODULE],
                        mmgroupBy: 'Stock',sortOrder:3,
                        groupBy: null,
                        submenu: null
                    },
                ]
            },
            // {
            //     id: 'audit-reports',
            //     text: 'Audit',
            //     icon: '',
            //     route: null,
            //     active: false,
            //     roles: [...REPORT_MODULE_ACCESS],
            //     megamenu: false,
            //     submenu: [
                  

            //     ]
            // },
            {
                id: 'help',
                text: 'Help',
                icon: '',
                route: null,
                active: false,
                roles: [...REPORT_MODULE_ACCESS],
                megamenu: false,
                submenu: [
                    {
                        id: 'Access Rights',
                        text: 'Access Rights',
                        icon: '',
                        route: 'help/access-rights',
                        active: false,
                        roles: ['COMPANY_ACCESS'],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'welcome',
                        text: 'Welcome',
                        icon: '',
                        route: 'help/welcome',
                        active: false,
                        roles: [...REPORT_MODULE_ACCESS],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'keyboard-shortcuts',
                        text: 'Keyboard Shortcuts',
                        icon: '',
                        route: 'help/keyboard-shortcuts',
                        active: false,
                        roles: [...REPORT_MODULE_ACCESS],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'manglish-layouts',
                        text: 'Manglish Layouts',
                        icon: '',
                        route: 'help/manglish-layouts',
                        active: false,
                        roles: [...REPORT_MODULE_ACCESS],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'licence',
                        text: 'Licence',
                        icon: '',
                        route: 'help/licence',
                        active: false,
                        roles: [...REPORT_MODULE_ACCESS],
                        groupBy: null,
                        submenu: null
                    },
                    {
                        id: 'about',
                        text: 'About',
                        icon: '',
                        route: 'help/about',
                        active: false,
                        roles: [...REPORT_MODULE_ACCESS],
                        groupBy: null,
                        submenu: null
                    },
                    
                    // {
                    //     id: 'stoda-editor',
                    //     text: 'STODA Editor',
                    //     icon: '',
                    //     route: 'help/stoda-editor',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // },
                    // {
                    //     id: 'documentation',
                    //     text: 'Documentation',
                    //     icon: '',
                    //     route: 'help/documentation',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // },                    
                    // {
                    //     id: 'view-license',
                    //     text: 'View License',
                    //     icon: '',
                    //     route: 'help/view-license',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // },
                    // {
                    //     id: 'feature-request',
                    //     text: 'Feature Request',
                    //     icon: '',
                    //     route: 'help/feature-request',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // },
                    // {
                    //     id: 'report-issue',
                    //     text: 'Report Issue',
                    //     icon: '',
                    //     route: 'help/report-issue',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // }
                    // ,
                    // {
                    //     id: 'privacy-statement',
                    //     text: 'Privacy Statement',
                    //     icon: '',
                    //     route: 'help/privacy-statement',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // },
                    // {
                    //     id: 'install-update',
                    //     text: 'Install Update',
                    //     icon: '',
                    //     route: 'help/install-update',
                    //     active: false,
                    //     roles: [
                    //         ...COMMON_ROLES,
                    //
                    //
                    //     ],
                    //     groupBy: null,
                    //     submenu: null
                    // }
                ]
            }
        ];

}


